export const products = [
  {
    id: 1,
    name: 'Whole Milk Sample',
    price: 65,
    image: '🥛',
    description: 'Fresh whole milk, 1 liter',
    category: 'Fresh Milk',
    fat: '3.5%'
  },
  {
    id: 2,
    name: 'Toned Milk',
    price: 55,
    image: '🥛',
    description: 'Healthy toned milk, 1 liter',
    category: 'Fresh Milk',
    fat: '3%'
  },
  {
    id: 3,
    name: 'Skimmed Milk',
    price: 50,
    image: '🥛',
    description: 'Low fat skimmed milk, 1 liter',
    category: 'Fresh Milk',
    fat: '0.5%'
  },
  {
    id: 4,
    name: 'Flavored Milk - Chocolate',
    price: 35,
    image: '🍫',
    description: 'Delicious chocolate milk, 200ml',
    category: 'Flavored',
    fat: '3%'
  },
  {
    id: 5,
    name: 'Flavored Milk - Strawberry',
    price: 35,
    image: '🍓',
    description: 'Sweet strawberry milk, 200ml',
    category: 'Flavored',
    fat: '3%'
  },
  {
    id: 6,
    name: 'Buttermilk',
    price: 30,
    image: '🥤',
    description: 'Refreshing buttermilk, 500ml',
    category: 'Dairy',
    fat: '1%'
  },
  {
    id: 7,
    name: 'Paneer',
    price: 120,
    image: '🧀',
    description: 'Fresh cottage cheese, 200g',
    category: 'Dairy',
    fat: '20%'
  },
  {
    id: 8,
    name: 'Curd',
    price: 40,
    image: '🥣',
    description: 'Fresh homemade curd, 500g',
    category: 'Dairy',
    fat: '4%'
  }
];

export const banners = [
  {
    id: 1,
    title: 'Fresh Milk Daily',
    subtitle: 'Farm to Doorstep in 24 Hours',
    background: 'from-blue-400 to-blue-600',
    icon: '🥛',
    offer: 'Free Delivery'
  },
  {
    id: 2,
    title: 'Subscribe & Save 10%',
    subtitle: 'Get Daily Milk Delivered',
    background: 'from-green-400 to-green-600',
    icon: '🔔',
    offer: 'Special Offer'
  },
  {
    id: 3,
    title: 'Pure & Natural',
    subtitle: '100% Organic Dairy Products',
    background: 'from-purple-400 to-purple-600',
    icon: '🌾',
    offer: 'Premium Quality'
  }
];

export const deliverySlots = [
  { id: 'morning', time: '6:00 AM - 8:00 AM', icon: '🌅', label: 'Morning' },
  { id: 'afternoon', time: '2:00 PM - 4:00 PM', icon: '☀️', label: 'Afternoon' },
  { id: 'evening', time: '6:00 PM - 8:00 PM', icon: '🌆', label: 'Evening' }
];

export const subscriptionPlans = [
  { id: 'daily', name: 'Daily', price: 1800, duration: 30, discount: 10 },
  { id: 'alternate', name: 'Alternate Days', price: 900, duration: 30, discount: 5 },
  { id: 'weekly', name: 'Weekly (7 days)', price: 420, duration: 7, discount: 5 }
];

export const notifications = [
  { id: 1, title: 'Order Delivered', message: 'Your order #1235 has been delivered', time: '2 hours ago', unread: true },
  { id: 2, title: 'Special Offer', message: 'Get 20% off on your next subscription', time: '1 day ago', unread: true },
  { id: 3, title: 'Payment Successful', message: 'Payment of ₹190 received', time: '2 days ago', unread: false }
];

export const locations = [
  'Gurugram, Haryana',
  'Delhi, Delhi',
  'Noida, Uttar Pradesh',
  'Ghaziabad, Uttar Pradesh',
  'Faridabad, Haryana'
];
